class ButtonState extends WidgetState {
    constructor() {
        super();
    }

    /**
     * check if two instances of widgetState are equal
     * @param otherWidgetState
     */
    equals(otherWidgetState) {
        if(this.enabled != null && otherWidgetState.enabled != null) {
            if(this.enabled != otherWidgetState.enabled) return false;
        }

        return true;
    }

    getCopy(): WidgetState {
        var result = new ButtonState();

        result.enabled = this.enabled;
        result.copyChildrenStates(this);

        return result;
    }
}
